import Concern from 'src/models/model/concerns/Concern'

/**
 * This concern is necessary for models that can have field values masked by the API.
 */
export default class FieldMaskable extends Concern {
  static hasMaskableFields = true

  get hasMaskableFields () {
    return true
  }

  static fields = {
    /**
     * This should not be `output: true` because we want to echo this back
     * to the API for additional checks. The API knows how to handle this field.
     */
    maskedFields: {
      type: [String],
      default: null
    }
  }
}
